import { IWelcomePage } from './types';

export default class WelcomePageFactory {
  static Create(): IWelcomePage {
    return {
      text: '',
      textColor: '#ffffff',
      imageUrl: '/DefaultWelcomePage.jpg',
      opacityPercent: 100,
    };
  }
}
